import type { TPageMapValue } from 'models/common.model'
import { lazy } from 'react'
import { PageIdIntl2Lw } from './pages'

type TIdToPageMapIntl2Lw = Record<PageIdIntl2Lw, TPageMapValue>

export const ID_TO_PAGE_MAP_INTL_2LW: TIdToPageMapIntl2Lw = {
  [PageIdIntl2Lw.ANALYZING]: {
    Component: lazy(() =>
      import('cohorts/intl_2lw/pages/urge/AnalyzingPage').then((m) => ({
        default: m.AnalyzingPage,
      })),
    ),
    preload: () => import('cohorts/intl_2lw/pages/urge/AnalyzingPage'),
  },
  [PageIdIntl2Lw.INTRO_CERTIFICATE]: {
    Component: lazy(() =>
      import('cohorts/intl_2lw/pages/urge/IntroCertificatePage').then((m) => ({
        default: m.IntroCertificatePage,
      })),
    ),
    preload: () => import('cohorts/intl_2lw/pages/urge/IntroCertificatePage'),
  },
  [PageIdIntl2Lw.START]: {
    Component: lazy(() =>
      import('cohorts/intl_2lw/pages/urge/StartPage').then((m) => ({
        default: m.StartPage,
      })),
    ),
    preload: () => import('cohorts/intl_2lw/pages/urge/StartPage'),
  },
  [PageIdIntl2Lw.QUESTION_1]: {
    Component: lazy(() =>
      import('cohorts/intl_2lw/pages/questions/Question1Page').then((m) => ({
        default: m.Question1Page,
      })),
    ),
    preload: () => import('cohorts/intl_2lw/pages/questions/Question1Page'),
  },
  [PageIdIntl2Lw.QUESTION_2]: {
    Component: lazy(() =>
      import('cohorts/intl_2lw/pages/questions/Question2Page').then((m) => ({
        default: m.Question2Page,
      })),
    ),
    preload: () => import('cohorts/intl_2lw/pages/questions/Question1Page'),
  },
  [PageIdIntl2Lw.QUESTION_3]: {
    Component: lazy(() =>
      import('cohorts/intl_2lw/pages/questions/Question3Page').then((m) => ({
        default: m.Question3Page,
      })),
    ),
    preload: () => import('cohorts/intl_2lw/pages/questions/Question3Page'),
  },
  [PageIdIntl2Lw.QUESTION_4]: {
    Component: lazy(() =>
      import('cohorts/intl_2lw/pages/questions/Question4Page').then((m) => ({
        default: m.Question4Page,
      })),
    ),
    preload: () => import('cohorts/intl_2lw/pages/questions/Question4Page'),
  },
  [PageIdIntl2Lw.SPEED_FEEDBACK]: {
    Component: lazy(() =>
      import('cohorts/intl_2lw/pages/urge/SpeedFeedbackPage').then((m) => ({
        default: m.SpeedFeedbackPage,
      })),
    ),
    preload: () => import('cohorts/intl_2lw/pages/urge/SpeedFeedbackPage'),
  },
  [PageIdIntl2Lw.QUESTION_5]: {
    Component: lazy(() =>
      import('cohorts/intl_2lw/pages/questions/Question5Page').then((m) => ({
        default: m.Question5Page,
      })),
    ),
    preload: () => import('cohorts/intl_2lw/pages/questions/Question5Page'),
  },
  [PageIdIntl2Lw.QUESTION_6]: {
    Component: lazy(() =>
      import('cohorts/intl_2lw/pages/questions/Question6Page').then((m) => ({
        default: m.Question6Page,
      })),
    ),
    preload: () => import('cohorts/intl_2lw/pages/questions/Question6Page'),
  },
  [PageIdIntl2Lw.QUESTION_7]: {
    Component: lazy(() =>
      import('cohorts/intl_2lw/pages/questions/Question7Page').then((m) => ({
        default: m.Question7Page,
      })),
    ),
    preload: () => import('cohorts/intl_2lw/pages/questions/Question7Page'),
  },
  [PageIdIntl2Lw.QUESTION_8]: {
    Component: lazy(() =>
      import('cohorts/intl_2lw/pages/questions/Question8Page').then((m) => ({
        default: m.Question8Page,
      })),
    ),
    preload: () => import('cohorts/intl_2lw/pages/questions/Question8Page'),
  },
  [PageIdIntl2Lw.QUESTION_9]: {
    Component: lazy(() =>
      import('cohorts/intl_2lw/pages/questions/Question9Page').then((m) => ({
        default: m.Question9Page,
      })),
    ),
    preload: () => import('cohorts/intl_2lw/pages/questions/Question9Page'),
  },
  [PageIdIntl2Lw.QUESTION_10]: {
    Component: lazy(() =>
      import('cohorts/intl_2lw/pages/questions/Question10Page').then((m) => ({
        default: m.Question10Page,
      })),
    ),
    preload: () => import('cohorts/intl_2lw/pages/questions/Question10Page'),
  },
  [PageIdIntl2Lw.QUESTION_11]: {
    Component: lazy(() =>
      import('cohorts/intl_2lw/pages/questions/Question11Page').then((m) => ({
        default: m.Question11Page,
      })),
    ),
    preload: () => import('cohorts/intl_2lw/pages/questions/Question11Page'),
  },
  [PageIdIntl2Lw.QUESTION_12]: {
    Component: lazy(() =>
      import('cohorts/intl_2lw/pages/questions/Question12Page').then((m) => ({
        default: m.Question12Page,
      })),
    ),
    preload: () => import('cohorts/intl_2lw/pages/questions/Question12Page'),
  },
  [PageIdIntl2Lw.SMARTNESS_FEEDBACK]: {
    Component: lazy(() =>
      import('cohorts/intl_2lw/pages/urge/SmartnessFeedbackPage').then((m) => ({
        default: m.SmartnessFeedbackPage,
      })),
    ),
    preload: () => import('cohorts/intl_2lw/pages/urge/SmartnessFeedbackPage'),
  },
  [PageIdIntl2Lw.QUESTION_13]: {
    Component: lazy(() =>
      import('cohorts/intl_2lw/pages/questions/Question13Page').then((m) => ({
        default: m.Question13Page,
      })),
    ),
    preload: () => import('cohorts/intl_2lw/pages/questions/Question13Page'),
  },
  [PageIdIntl2Lw.QUESTION_14]: {
    Component: lazy(() =>
      import('cohorts/intl_2lw/pages/questions/Question14Page').then((m) => ({
        default: m.Question14Page,
      })),
    ),
    preload: () => import('cohorts/intl_2lw/pages/questions/Question14Page'),
  },
  [PageIdIntl2Lw.QUESTION_15]: {
    Component: lazy(() =>
      import('cohorts/intl_2lw/pages/questions/Question15Page').then((m) => ({
        default: m.Question15Page,
      })),
    ),
    preload: () => import('cohorts/intl_2lw/pages/questions/Question15Page'),
  },
  [PageIdIntl2Lw.QUESTION_16]: {
    Component: lazy(() =>
      import('cohorts/intl_2lw/pages/questions/Question16Page').then((m) => ({
        default: m.Question16Page,
      })),
    ),
    preload: () => import('cohorts/intl_2lw/pages/questions/Question16Page'),
  },
  [PageIdIntl2Lw.QUESTION_17]: {
    Component: lazy(() =>
      import('cohorts/intl_2lw/pages/questions/Question17Page').then((m) => ({
        default: m.Question17Page,
      })),
    ),
    preload: () => import('cohorts/intl_2lw/pages/questions/Question17Page'),
  },
  [PageIdIntl2Lw.QUESTION_18]: {
    Component: lazy(() =>
      import('cohorts/intl_2lw/pages/questions/Question18Page').then((m) => ({
        default: m.Question18Page,
      })),
    ),
    preload: () => import('cohorts/intl_2lw/pages/questions/Question18Page'),
  },
  [PageIdIntl2Lw.QUESTION_19]: {
    Component: lazy(() =>
      import('cohorts/intl_2lw/pages/questions/Question19Page').then((m) => ({
        default: m.Question19Page,
      })),
    ),
    preload: () => import('cohorts/intl_2lw/pages/questions/Question19Page'),
  },
  [PageIdIntl2Lw.QUESTION_20]: {
    Component: lazy(() =>
      import('cohorts/intl_2lw/pages/questions/Question20Page').then((m) => ({
        default: m.Question20Page,
      })),
    ),
    preload: () => import('cohorts/intl_2lw/pages/questions/Question20Page'),
  },
  [PageIdIntl2Lw.LOGICAL_SKILLS_FEEDBACK]: {
    Component: lazy(() =>
      import('cohorts/intl_2lw/pages/urge/LogicSkillFeedback').then((m) => ({
        default: m.LogicalSkillsFeedbackPage,
      })),
    ),
    preload: () => import('cohorts/intl_2lw/pages/urge/LogicSkillFeedback'),
  },
  [PageIdIntl2Lw.QUESTION_21]: {
    Component: lazy(() =>
      import('cohorts/intl_2lw/pages/questions/Question21Page').then((m) => ({
        default: m.Question21Page,
      })),
    ),
    preload: () => import('cohorts/intl_2lw/pages/questions/Question21Page'),
  },
  [PageIdIntl2Lw.QUESTION_22]: {
    Component: lazy(() =>
      import('cohorts/intl_2lw/pages/questions/Question22Page').then((m) => ({
        default: m.Question22Page,
      })),
    ),
    preload: () => import('cohorts/intl_2lw/pages/questions/Question22Page'),
  },
  [PageIdIntl2Lw.QUESTION_23]: {
    Component: lazy(() =>
      import('cohorts/intl_2lw/pages/questions/Question23Page').then((m) => ({
        default: m.Question23Page,
      })),
    ),
    preload: () => import('cohorts/intl_2lw/pages/questions/Question23Page'),
  },
  [PageIdIntl2Lw.QUESTION_24]: {
    Component: lazy(() =>
      import('cohorts/intl_2lw/pages/questions/Question24Page').then((m) => ({
        default: m.Question24Page,
      })),
    ),
    preload: () => import('cohorts/intl_2lw/pages/questions/Question24Page'),
  },
  [PageIdIntl2Lw.QUESTION_25]: {
    Component: lazy(() =>
      import('cohorts/intl_2lw/pages/questions/Question25Page').then((m) => ({
        default: m.Question25Page,
      })),
    ),
    preload: () => import('cohorts/intl_2lw/pages/questions/Question25Page'),
  },
  [PageIdIntl2Lw.AGE_QUESTION]: {
    Component: lazy(() =>
      import('cohorts/intl_2lw/pages/questions/AgeQuestionPage').then((m) => ({
        default: m.AgeQuestionPage,
      })),
    ),
    preload: () => import('cohorts/intl_2lw/pages/questions/AgeQuestionPage'),
  },
  [PageIdIntl2Lw.EDUCATION_QUESTION]: {
    Component: lazy(() =>
      import('cohorts/intl_2lw/pages/questions/EducationQuestionPage').then(
        (m) => ({
          default: m.EducationQuestionPage,
        }),
      ),
    ),
    preload: () =>
      import('cohorts/intl_2lw/pages/questions/EducationQuestionPage'),
  },
  [PageIdIntl2Lw.DISCOVER_FEEDBACKS]: {
    Component: lazy(() =>
      import('cohorts/intl_2lw/pages/urge/DiscoverFeedbacksPage').then((m) => ({
        default: m.DiscoverFeedbacksPage,
      })),
    ),
    preload: () => import('cohorts/intl_2lw/pages/urge/DiscoverFeedbacksPage'),
  },
  [PageIdIntl2Lw.PREPARE_FLOW]: {
    Component: lazy(() =>
      import('cohorts/intl_2lw/pages/prepareFlow/PrepareFlow').then((m) => ({
        default: m.PrepareFlow,
      })),
    ),
    preload: () => import('cohorts/intl_2lw/pages/prepareFlow/PrepareFlow'),
  },
  [PageIdIntl2Lw.EMAIL]: {
    Component: lazy(() =>
      import('cohorts/intl_2lw/pages/email/EmailPage').then((m) => ({
        default: m.EmailPage,
      })),
    ),
    preload: () => import('cohorts/intl_2lw/pages/email/EmailPage'),
  },
  [PageIdIntl2Lw.EMAIL_CONSENT]: {
    Component: lazy(() =>
      import('cohorts/intl_2lw/pages/emailConsent/EmailConsentPage').then(
        (m) => ({
          default: m.EmailConsentPage,
        }),
      ),
    ),
    preload: () =>
      import('cohorts/intl_2lw/pages/emailConsent/EmailConsentPage'),
  },
  [PageIdIntl2Lw.OFFER]: {
    Component: lazy(() =>
      import('cohorts/intl_2lw/pages/offer/OfferPage').then((m) => ({
        default: m.OfferPage,
      })),
    ),
    preload: () => import('cohorts/intl_2lw/pages/offer/OfferPage'),
  },
  [PageIdIntl2Lw.SPECIAL_DISCOUNT]: {
    Component: lazy(() =>
      import('cohorts/intl_2lw/pages/specialDiscount/SpecialDiscountPage').then(
        (m) => ({
          default: m.SpecialDiscountPage,
        }),
      ),
    ),
    preload: () =>
      import('cohorts/intl_2lw/pages/specialDiscount/SpecialDiscountPage'),
  },
  [PageIdIntl2Lw.CANCEL_OFFER]: {
    Component: lazy(() =>
      import('cohorts/intl_2lw/pages/cancelOffer/CancelOfferPage').then(
        (m) => ({
          default: m.CancelOfferPage,
        }),
      ),
    ),
    preload: () => import('cohorts/intl_2lw/pages/cancelOffer/CancelOfferPage'),
  },
  [PageIdIntl2Lw.PAYMENT]: {
    Component: lazy(() =>
      import('cohorts/intl_2lw/pages/payment/PaymentPage').then((m) => ({
        default: m.PaymentPage,
      })),
    ),
    preload: () => import('cohorts/intl_2lw/pages/payment/PaymentPage'),
  },
  [PageIdIntl2Lw.CHECKOUT]: {
    Component: lazy(() =>
      import('cohorts/intl_2lw/pages/checkout/CheckoutPage').then((m) => ({
        default: m.CheckoutPage,
      })),
    ),
    preload: () => import('cohorts/intl_2lw/pages/checkout/CheckoutPage'),
  },
  [PageIdIntl2Lw.UPSELL]: {
    Component: lazy(() =>
      import('cohorts/intl_2lw/pages/upsell/UpsellPage').then((m) => ({
        default: m.UpsellPage,
      })),
    ),
    preload: () => import('cohorts/intl_2lw/pages/upsell/UpsellPage'),
  },
  [PageIdIntl2Lw.REGISTRATION]: {
    Component: lazy(() =>
      import('cohorts/intl_2lw/pages/account/AccountNove8').then((m) => ({
        default: m.AccountNove8,
      })),
    ),
    preload: () => import('cohorts/intl_2lw/pages/account/AccountNove8'),
  },
  [PageIdIntl2Lw.NAME_ENTRY]: {
    Component: lazy(() =>
      import('cohorts/intl_2lw/pages/name/NamePage').then((m) => ({
        default: m.NamePage,
      })),
    ),
    preload: () => import('cohorts/intl_2lw/pages/name/NamePage'),
  },
  [PageIdIntl2Lw.CERTIFICATE]: {
    Component: lazy(() =>
      import('cohorts/intl_2lw/pages/certificate/CertificatePage').then(
        (m) => ({
          default: m.CertificatePage,
        }),
      ),
    ),
    preload: () => import('cohorts/intl_2lw/pages/certificate/CertificatePage'),
  },
  [PageIdIntl2Lw.LEARNWORLDS_REDIRECT]: {
    Component: lazy(() =>
      import('cohorts/intl_2lw/pages/learnWorldsRedirect/LearnWorldsRedirectPage').then(
        (m) => ({
          default: m.LearnWorldsRedirectPage,
        }),
      ),
    ),
    preload: () =>
      import('cohorts/intl_2lw/pages/learnWorldsRedirect/LearnWorldsRedirectPage'),
  },
  [PageIdIntl2Lw.REPORT]: {
    Component: lazy(() =>
      import('cohorts/intl_2lw/pages/report/ReportPage').then((m) => ({
        default: m.ReportPage,
      })),
    ),
    preload: () => import('cohorts/intl_2lw/pages/report/ReportPage'),
  },
}
